import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase/firebase";

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Log page visit event
    logEvent(analytics, "page_view", {
      page_path: location.pathname, // Track the current path
      page_title: document.title, // Track the page title
    });
    // console.log("Page view logged:", location.pathname);
  }, [location]);

  return null;
}
